/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsAdvertisementFbInstantRewardedOptions
 */
export interface FxIdDomainSettingsAdvertisementFbInstantRewardedOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsAdvertisementFbInstantRewardedOptions
     */
    DefaultPlacementId: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementFbInstantRewardedOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementFbInstantRewardedOptions(value: object): value is FxIdDomainSettingsAdvertisementFbInstantRewardedOptions {
    if (!('DefaultPlacementId' in value) || value['DefaultPlacementId'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsFromJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantRewardedOptions {
    return FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementFbInstantRewardedOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'DefaultPlacementId': json['DefaultPlacementId'],
    };
}

export function FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsToJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantRewardedOptions {
    return FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantRewardedOptionsToJSONTyped(value?: FxIdDomainSettingsAdvertisementFbInstantRewardedOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DefaultPlacementId': value['DefaultPlacementId'],
    };
}

